<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs">Usuarios de sistema</p>
        <h2 class="">Usuarios de sistema</h2>
    </div>
    <dx-button text="Nuevo usuario" icon="plus" type="default" (onClick)="grid.instance.addRow()">
    </dx-button>
</div>
<div class="dx-card content-block">
    <div class="responsive-paddings">
        <dx-data-grid #grid [dataSource]="usersList" keyExpr="id" [allowColumnReordering]="true"
            (onEditCanceled)="onEditCanceled($event)"
            (onInitNewRow)="onInitNewRow($event)"
            (onEditingStart)="onEditingStart($event)"
            (onEditorPreparing)="onEditorPreparing($event)"
            (onEditorPrepared)="onEditorPrepared($event)"
            (onRowInserting)="createUser($event)" (onRowUpdating)="updateUser($event)"
            (onRowRemoving)="deleteData($event.key)" [masterDetail]=" { enabled: true, template: 'detail' ,
            autoExpandAll: false }" showBorders="true">
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxo-header-filter visible="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
            <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="true">
                <dxo-popup title="Nuevo usuario" [showTitle]="true" [width]="850" [height]="750"></dxo-popup>
                <dxo-form>
                    <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
                    <dxi-item dataField="name" dataType="string">
                        <dxo-label text="Nombre"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    </dxi-item>
                    <dxi-item dataField="lastName" dataType="string" [isRequired]="false">
                        <dxo-label text="Primer apellido"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="secondLastName" dataType="string" [isRequired]="false">
                        <dxo-label text="Segundo apellido"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="phone" dataType="string" [isRequired]="false">
                        <dxo-label text="Teléfono"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="email" dataType="string" [isRequired]="false">
                        <dxo-label text="e-mail"></dxo-label>
                        <dxi-validation-rule type="required" message="Email is invalid">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [disabled]="disabledLevel" dataField="level" dataType="string" [isRequired]="false">
                        <dxo-label text="Nivel de acceso"></dxo-label>
                        <dxo-lookup [dataSource]="userLevel" displayExpr="name" valueExpr="level"></dxo-lookup>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [disabled]="disabledCompany" [visible]="visibleCompany" dataField="companyId" dataType="string" [isRequired]="false">
                        <dxo-label text="Compañia"></dxo-label>
                        <dxo-lookup [dataSource]="companies" displayExpr="companyName" valueExpr="id"></dxo-lookup>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [disabled]="disabledCompanies" [visible]="visibleCompanies" dataField="companyList" [isRequired]="false">
                        <dxo-label text="Lista Compañias"></dxo-label>
                    </dxi-item>
                    <div *dxTemplate="let companiesTem of 'companiesTemplate'">
                        <dx-tag-box [dataSource]="companies" [hideSelectedItems]="false" [(value)]="companiesTem.value" (onValueChanged)="setEditedValue($event, companiesTem)" displayExpr="companyName" valueExpr="this"></dx-tag-box>
                    </div>

                    <!-- <dxi-item [disabled]="disabledCompanies" [visible]="visibleCompanies" name="show-companies" dataType="string" [isRequired]="false">
                        <dxo-label text="Compañias"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box [(value)]="companySelected.id" [dataSource]="companies"
                                displayExpr="companyName" valueExpr="id"  (onValueChanged)="changeCompanie($event)">
                            </dx-select-box>
                            <div *ngFor="let item of listCompanies; let indice=index;">
                                <div class="chip" *ngIf="item!=undefined">
                                    <div class="chip-content">{{item.companyName}}</div>
                                    <div class="chip-close" (click)="deleteCompanyList(item,indice)">
                                        <svg class="chip-svg" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item> -->
                </dxo-form>
            </dxo-editing>

            <dxi-column dataField="name" caption="Nombre">
                <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column dataField="lastName" caption="Primer apellido" dataType="string">
                <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column dataField="secondLastName" caption="Segundo apellido" dataType="string">
                <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column dataField="phone" caption="Teléfono" dataType="string"
                [editorOptions]="{ mask: '(000)-000-00-00'}">
                <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column dataField="email" caption="e-mail" dataType="string">
                <dxi-validation-rule type="email" message="Email is invalid">
                </dxi-validation-rule>
                <dxi-validation-rule type="required" message="Required">
                </dxi-validation-rule>
            </dxi-column>
            <dxi-column dataField="level" caption="Nivel de acceso">
                <dxo-lookup [dataSource]="userLevel" displayExpr="name" valueExpr="level"></dxo-lookup>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [visible]="false" dataField="companyId" caption="Nombre Compañia">
                <dxo-lookup [dataSource]="companies" displayExpr="companyName" valueExpr="id"></dxo-lookup>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [visible]="false" dataField="companyList" cellTemplate="cellCompanyListTemplate" editCellTemplate="companiesTemplate" caption="Lista Compañias">
            </dxi-column>
            <div *dxTemplate="let cellCompanyList of 'cellCompanyListTemplate'">
                <dx-tag-box [dataSource]="companies" [value]="cellCompanyList.data.companyList" displayExpr="companyName" valueExpr="id"></dx-tag-box>
            </div>

            <div *dxTemplate="let user of 'detail'">
                <div class="flex flex-nowrap flex-start datagrid-detailsW">
                    <div class="mr-5 ml-5">
                        <h2>Detalle de usuario</h2>
                        <ul>
                            <li>Nombre: {{user.data.name}} {{user.data.middleName}} {{user.data.lastName}}
                                {{user.data.secondLastName}}</li>
                            <li>Email: {{user.data.email}}</li>
                            <li>Tel: {{user.data.phone}}</li>
                            <li>Nivel:
                                <span *ngIf="user.data.level === 4">Administrador</span>
                                <span *ngIf="user.data.level === 5">Usuario</span>
                                <span *ngIf="user.data.level === 6">Reportes</span>
                            </li>
                            <li>Id: {{user.data.id}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </dx-data-grid>
    </div>
</div>